export default "__VITE_ASSET__1d28852c__"